import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { themeGet } from '@styled-system/theme-get';

const StyledAccordion = styled(AccordionPrimitive.Root).withConfig({
  displayName: "Accordion__StyledAccordion",
  componentId: "sc-rokb8x-0"
})(["> * + *{margin-top:", ";}"], _ref => {
  let {
    spacing
  } = _ref;
  return spacing ? themeGet(`space.${spacing}`) : '-1px';
});
/**
 * Accordion allows users to expand one or more panels at a time, revealing information
 * within a small space.
 *
 * _Note_: AccordionHeader and AccordionPanels have default padding of 'lg', which can be overridden.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 *  <br />
 *
 */
const Accordion = _ref2 => {
  let {
    dataTestId = 'accordion',
    type = 'single',
    collapsible = true,
    children,
    spacing,
    ...props
  } = _ref2;
  return (
    /*#__PURE__*/
    // @ts-ignore - TODO: value, onValueChange, defaultValue props don't align with root props
    React__default.createElement(StyledAccordion, _extends({}, collapsible && {
      collapsible: 'true'
    }, {
      "data-test-id": dataTestId,
      spacing: spacing,
      type: type
    }, props), children)
  );
};
Accordion.displayName = 'Accordion';

export { Accordion };
